export class FetchError extends Error {
    constructor(message, response) {
        super(message);
        this.name = "FetchError";
        this.response = response;
    }
}
